module.exports = __webpack_public_path__ + "img/right-nav01.a20c6078.png";